import { Link as ExpoLink, type Href, router } from 'expo-router'
import type { ReactNode } from 'react'
import { Pressable, type StyleProp, type ViewStyle } from 'react-native'
import { Button, type ButtonProps } from '@/ui/Button'

interface AppLinkProps {
    href: string
    children: ReactNode
    style?: StyleProp<ViewStyle>
}

export interface ButtonLinkProps extends Omit<ButtonProps, 'onPress'> {
    href: string
    replace?: boolean
}

export const Link = ({ href, children }: AppLinkProps) => {
    return (
        <ExpoLink href={href as Href} asChild>
            <Pressable style={{ flex: 1 }}>{children}</Pressable>
        </ExpoLink>
    )
}

export const ButtonLink = ({ href, replace, ...buttonProps }: ButtonLinkProps) => {
    return (
        <Button
            {...buttonProps}
            mode={buttonProps.mode || 'contained'}
            onPress={() => (replace ? router.replace(href as Href) : router.push(href as Href))}
        />
    )
}
